export const LEGACY_LAST_SEARCH_STORAGE_KEY = 'aviata:tours-last-search';
export const SEARCH_HISTORY_STORAGE_KEY = 'aviata:tours-search-history';
export const EXPIRE_THRESHOLD_DAY_COUNT = 1;
